export const CHECKOUT_MODE_PARAM = 'mode';

export enum CheckoutMode {
  REDIRECT = 'redirect',
}
